import type { FieldValues, UseFormSetError } from 'libs/form'

type ApiFieldError = string | string[] | { [field: string]: ApiFieldError }

export type ApiFieldErrors = Record<string, ApiFieldError>

export const setApiFieldErrors = (
	setError: UseFormSetError<FieldValues>,
	errors: ApiFieldErrors | undefined,
	prefix = ''
) => {
	if (!errors || typeof errors !== 'object') return

	Object.entries(errors).forEach(([field, value]) => {
		const path = prefix ? `${prefix}.${field}` : field

		if (typeof value === 'string') {
			setError(path, { type: 'server', message: value })
		} else if (Array.isArray(value)) {
			setError(path, { type: 'server', message: value.join(' ') })
		} else {
			setApiFieldErrors(setError, value, path)
		}
	})
}
